import React, { useState } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import ModalLogin from '../../Containers/Modal_Login';
import ModalRegister from '../../Containers/Modal_Register';
import ModalSuccess from '../../Containers/ModalSuccess';
import ModalResult from '../../Containers/ModalResult';
import { Document, Page, pdfjs } from 'react-pdf';
import './style.scss';
const Tabs = [
  {
    id: 0,
    name: 'Chuyển đổi số cho doanh nghiệp Việt Nam',
  },
  {
    id: 1,
    name: 'Tạo tài khoản trên SMEdx.vn',
  },
];

const HowtousePage = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [tabId, setTabId] = useState(0);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  return (
    <div className='faq-page'>
      <Header />
      <main>
        <div className='faq'>
          <div className='container'>
            <div className='header'>
              <h2 className='title'>
                <span className='black'>Hướng dẫn</span>{' '}
                <span className='red'>sử dụng</span>
              </h2>
              <p className='des'>
                Tài liệu hướng dẫn chuyển đổi số và sử dụng chức năng trên SMEdx
              </p>
            </div>
            <ul className='news__tab nav flex'>
              {Tabs.map(({ id, name }) => {
                return (
                  <li key={id} style={{ cursor: 'pointer' }}>
                    <a
                      onClick={(e) => {
                        setTabId(id);
                        setPageNumber(1);
                      }}
                      data-toggle='tab'
                      title=''
                      className={id === tabId ? 'active' : ''}
                    >
                      {name}
                    </a>
                  </li>
                );
              })}
            </ul>
            {tabId === 0 && (
              <div className='pdf-container'>
                <Document
                  file='/smedx/Huong_dan_chuyen_doi_so.pdf'
                  onLoadSuccess={onDocumentLoadSuccess}
                  className='pdf-viewer'
                >
                  <Page pageNumber={pageNumber} />
                </Document>
                <div className='pdf-pages'>
                  <button
                    className='pdf-control'
                    onClick={() =>
                      pageNumber > 1 && setPageNumber(pageNumber - 1)
                    }
                  >
                    {'<'}
                  </button>
                  <p>
                    Trang {pageNumber} / {numPages}
                  </p>
                  <button
                    className='pdf-control'
                    onClick={() =>
                      pageNumber < numPages && setPageNumber(pageNumber + 1)
                    }
                  >
                    {'>'}
                  </button>
                </div>
              </div>
            )}
            {tabId === 1 && (
              <div className='pdf-container'>
                <Document
                  file='/smedx/HUONG_DAN_TAO_TAI_KHOAN_VA_DANG_NHAP_WEBSITE_SMEdx.pdf'
                  onLoadSuccess={onDocumentLoadSuccess}
                  className='pdf-viewer'
                >
                  <Page pageNumber={pageNumber} />
                </Document>
                <div className='pdf-pages'>
                  <button
                    className='pdf-control'
                    onClick={() =>
                      pageNumber > 1 && setPageNumber(pageNumber - 1)
                    }
                  >
                    {'<'}
                  </button>
                  <p>
                    Trang {pageNumber} / {numPages}
                  </p>
                  <button
                    className='pdf-control'
                    onClick={() =>
                      pageNumber < numPages && setPageNumber(pageNumber + 1)
                    }
                  >
                    {'>'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <ModalLogin />
        <ModalRegister />
        <ModalSuccess />
      </main>
      <Footer />
    </div>
  );
};
export default HowtousePage;
